import React, { useEffect, useState, useRef, us } from 'react';
import './SupplyOrder.css';
import { useHistory, Redirect } from 'react-router-dom';
import {
    makeStyles, Paper, TableBody, TableRow, TableCell, Button, CircularProgress
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { useForm } from 'react-hook-form';
import clsx from 'clsx';
import { v4 as uuidv4 } from 'uuid';
import db, { storage } from '../../../Backend/firebase/firebase';

import CustomAlert from '../../CustomAlert';
import CheckUserProvider from '../../../AllHooks/CheckUserProvider';
import { Helmet } from 'react-helmet';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import * as XLSX from 'xlsx'
import useTable from '../../useTable';

const useStyles = makeStyles((theme) => ({
    root: {

    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'initial',
        flexDirection: 'column',
        width: '100%'
    },
    fixedHeight: {
        height: '100%',
        padding: '20px'
    },
}));

const headCells = [
    { id: 'ProductName', label: 'Chemist Info', disableSorting: false },
    { id: 'Compositions', label: 'Product Name', disableSorting: true },
    { id: 'PackagingType', label: 'Medicine Type', disableSorting: false },
    { id: 'ProductType', label: 'Product Type', disableSorting: true },
    { id: 'MRP', label: 'Quantity', disableSorting: true },
    { id: 'HSNCode', label: 'Quantity Type', disableSorting: false },
    { id: 'Discount', label: 'Quantity Type', disableSorting: false },
    { id: 'BatchNo', label: 'Quantity Type', disableSorting: false },
    { id: 'Company', label: 'Quantity Type', disableSorting: false },
    { id: 'Rate', label: 'Quantity Type', disableSorting: false }
]

function WholesalerImportProduct() {
    const { handleSubmit } = useForm();
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const [openNotify, setOpenNotify] = React.useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { userData } = CheckUserProvider();
    const fileInput = useRef(null);
    const history = useHistory();
    const [isUploading, setIsUploading] = useState(false);
    const [excelJsonRecord, setExcelJsonRecord] = useState(null);
    var batch = db.batch()

    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const [searchChange, setSearchChange] = useState(false);
    const [pageAfterSearch, setPageAfterSearch] = useState(false);
    const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } = useTable(excelJsonRecord, headCells, filterFn,
        searchChange, pageAfterSearch);

    const handleSearch = (e) => {
        let target = e.target;
        if (target.value === '') {
            setSearchChange(false);
            setPageAfterSearch(false);
        }
        else {
            setSearchChange(true);
            setPageAfterSearch(true);
        }
        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items
                } else {
                    return items?.filter(x => x?.ProductName?.toLowerCase()?.includes(target.value.toLowerCase()) ||
                                                x?.Compositions?.toLowerCase()?.includes(target.value.toLowerCase()) || 
                                                x?.ProductType?.toLowerCase()?.includes(target.value.toLowerCase()) ||
                                                x?.Company?.toLowerCase()?.includes(target.value.toLowerCase()));
                }
            }
        });
    };

    const readUploadFile = (e) => {
        e.preventDefault();
        try {
            if (e.target.files) {
                // setIsUploading(true);
                const files = e.target.files;
                const reader = new FileReader();
                const rABS = !!reader.readAsBinaryString;
            
                reader.onload = (e) => {
                    /* Parse data */
                    const bstr = e.target.result;
                    const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA : true });
                    /* Get first worksheet */
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    /* Convert array of arrays */
                    const data = XLSX.utils.sheet_to_json(ws, {
                        raw: false,
                        header: ws ? 0 : 1,
                        dateNF: "dd/mm/yyyy"
                    });
                    /* Update state */
                    console.log(JSON.stringify(data, null, 2));
                    setExcelJsonRecord(data)
                    setIsUploading(false);
                };
            
                if (rABS) {
                    reader.readAsBinaryString(files[0]);
                } else {
                    reader.readAsArrayBuffer(files[0]);
                };
            } else {
                setIsUploading(false);
            }
        } catch (error) {
            setIsUploading(false);
        }
    }

    const onSubmit = async () => {
        console.log("excelJsonRecord",excelJsonRecord)

        if(excelJsonRecord && excelJsonRecord != null) {
            let excelJson = excelJsonRecord.map(function (obj) {
                const uniqueId = uuidv4();
    
                obj['userId'] = userData.uid; 
                obj['uniqueId'] = uniqueId;
                obj['ProductPostedDateTime'] = new Date();
    
                obj['ProductDescription'] = ""; 
                obj['ProductStatus'] = "New"; 
         
                return obj;
            });
            try {
                console.log("excelJson",excelJson)
                setIsLoading(true);
                await excelJson.map(async (doc)=> {
                    const collectionRef = await db.collection('Products').doc();
                    batch.set(collectionRef, doc);
                });
                batch.commit().then(() => {
                    setNotificationMessage('Product created successfully.');
                    setOpenNotify(true);
                    setAlertType('success');
                    setIsLoading(false);
                    setTimeout(routeToPages, 1500);
                }).catch((error)=> {
                    console.error(error);
                    setNotificationMessage('Something went wrong, Please try again later!!');
                    setOpenNotify(true);
                    setAlertType('error');
                    setIsLoading(false);
                    history.push('/retailer/create-product');
                });
            }  catch (error) {
                console.error(error);
                setNotificationMessage('Something went wrong, Please try again later!!');
                setOpenNotify(true);
                setAlertType('error');
                setIsLoading(false);
                history.push('/retailer/create-product');
            }
        } else {
            setNotificationMessage('Please Upload CSV or Excel File!!');
            setOpenNotify(true);
            setAlertType('error');
        }
    };

    const routeToPages = () => {
        setExcelJsonRecord(null);
        window.location.pathname = '/wholesaller/import';
    }

    return (
        <>
            <div className="createProduct mt-2">
                <Helmet>
                    <meta name="description" content="Creating new product page." />
                    <title>Create new product | Kaipsool Pharmatech</title>
                </Helmet>
                <Paper className={fixedHeightPaper}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="row">

                            <div className="col-md-2 mb-2 createProduct__labelValign">
                                Upload Excel <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                            </div>
                            
                            <div className="col-md-10 mb-2">
                                <div className="form-group">
                                    <div className="d-flex align-items-center">
                                        <input type="file" accept=".csv,.xlsx,.xlsm" ref={fileInput}
                                            onChange={readUploadFile} style={{ display: 'none' }} />
                                        <Button
                                            variant="contained"
                                            color="default"
                                            startIcon={<CloudUploadIcon />}
                                            disabled={isUploading}
                                            onClick={() => fileInput.current.click()}>
                                            Upload Excel File <small>(accept csv,.xlsx)</small>
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 text-right mt-4">
                                <div className="d-flex">
                                    <div className="">
                                        <Button type="submit" variant="contained" className="registerEmp__btnLogin">
                                            {isLoading ? <CircularProgress size={18} /> : 'Import From Excel'}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    {(excelJsonRecord && excelJsonRecord != null) && <div className="col-sm-12 mt-4">
                        <hr />
                        <div className="d-flex justify-content-between mb-3">
                            <h5>Preview:</h5>
                            <div className="col-md-4">
                                <div className="d-flex justify-content-center w-100 align-items-center allProductsTable__searchBox">
                                    <SearchIcon className="mr-2" />
                                    <input type="text" placeholder="Search Product..." className="border-0"
                                        onChange={handleSearch} />
                                </div>
                            </div>
                        </div>
                        <div className="row col-md-12 supply-order-table supply-order-table-preview">
                            <TblContainer>
                                <TblHead />
                                <TableBody>
                                    {
                                        recordsAfterPagingAndSorting().map(item => (
                                            <TableRow key={item.id}>
                                                <TableCell>{item.ProductName ? item.ProductName : "NA"}</TableCell>
                                                <TableCell>{item.Compositions ? item.Compositions : "NA"}</TableCell>
                                                <TableCell>{item.PackagingType ? item.PackagingType : "Generic"}</TableCell>
                                                <TableCell>{item.ProductType ? item.ProductType : "NA"}</TableCell>
                                                <TableCell>{item.MRP ? `Rs. ${item.MRP}` : "NA"}</TableCell>
                                                <TableCell>{item.HSNCode ? item.HSNCode : "NA"}</TableCell>
                                                <TableCell>{item.Discount ? item.Discount : "NA"}</TableCell>
                                                <TableCell>{item.BatchNo ? item.BatchNo : "NA"}</TableCell>
                                                <TableCell>{item.Company ? item.Company : "NA"}</TableCell>
                                                <TableCell>{item.Rate ? item.Rate : "NA"}</TableCell>
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </TblContainer>
                            <TblPagination />
                        </div>
                    </div>}
                </Paper>
            </div>
            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType}
                notificationMessage={notificationMessage} verticalPosition="bottom" horizontalPosition="center" />
        </>
    )
}

export default WholesalerImportProduct

